import { useQuery } from 'react-query';
import { getFileUrl } from '../../api/studiesAPI';
import PDFViewer from './PDFViewer';
import Loader from '../ui/Loader';

/** Use this component to load an app document by name
 * i.e:
 * documentName = '1695863834776_Protocol_document_test.pdf'
 * <PDFDocumentViewer documentName={documentName} />
 */
const PDFDocumentViewer = ({ documentName }) => {
	const shouldFetch =
		documentName && documentName !== 'waiting';
	
	const { isLoading, data } = useQuery({
		queryKey: ['get-document-url', documentName],
		queryFn: () => getFileUrl(documentName),
		retry: false,
		staleTime: 3000000,
		enabled: shouldFetch
	});

	let documentUrl;

	if (isLoading || !shouldFetch) {
		return <Loader />;
	}

	if (!isLoading) {
		documentUrl = data.data.fileUrl;
	}

	return <PDFViewer pdfUrl={documentUrl} />;
};

export default PDFDocumentViewer;
